<template>
  <section class="crfq-parts">
    <div class="pull-right tools" v-if="checkClaim(CAN_ADD_SOURCING_CENTER)">
      <b-button @click="onCreateUltraRfp" size="sm" variant="primary">
        <i class="fa fa-plus-circle" aria-hidden="true"></i>
        Create RFP
      </b-button>
    </div>
    <grid-component
      isResizable
      isReorderable
      :gridId="gridId"
      :itemData="requirementLines"
      :fields="fields"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :navigationField="'partNumber'"
    />
  </section>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import debounce from 'lodash/debounce';

  import { date } from '@/shared/filters';
  import { GRID_ID } from '@/shared/constants';
  import { prepareColumnsData } from '@/shared/helpers';

  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';

  //import crfqPartsService from './service';
  import fields from '@/pages/Requirements/fields';

  export default {
    components: {
      GridSettings,
      GridComponent
    },
    props: {
      crfqId: {
        type: [Number, String],
        default: 0
      }
    },
    data: () => ({
      date,
      prepareColumnsData,
      fields,
      hasRfp: false,
      gridId: GRID_ID.REQUIREMENT_REQUESTED_PARTS
    }),
    computed: {
      ...mapState('requirementAdd', [
        'requirementLines',
      ]),
      /*...mapState('requirements', [
        'crfqPartsList',
      ]),*/
      //...mapGetters('requirements', ['crfqPartsList']),
      ...mapGetters('account', ['gridSettingsById']),
      gridSettings() {
        return this.gridSettingsById(GRID_ID.ADD_REQUIREMENT_CRFQ_PARTS);
      },
      deletePartTooltipTitle: function () {
        if (this.hasRfp) {
          return 'Cannot delete - RFP for this CRFQ exists';
        }
        return '';
      },
      requirementId() {
        return this.$route.params.crfqId;
      },
    },
    methods: {
      //...mapActions('crfqPart', ['getPartsForRequirement']),
      ...mapActions('requirements', [
        'getPartsForRequirement',
        'checkIfCrfqHasRfp',
        'createUltraRfp',
      ]),
      ...mapActions('requirementAdd', [
        'getCrfqPartById',
        'getRequirementLines',
        'deleteRequirementLine',
      ]),
      ...mapActions('account', ['saveGridSettings']),
      async onEdit(row) {

        this.$router.push({
          name: 'requirements.crfq',
          query: { crfqId: row.requirementId, crfqLineId: row.id, partId: row.partId },
        });

        //this.$router.go();
      },
      async onDelete({ id, requirementId }) {
        const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete requirement line?`});
        if (deleteConfirmed) {
          //await this.deleteCrfqPart(part.id);
          await this.deleteRequirementLine({ id, requirementId });
          await this.getPartsForRequirement(this.crfqId);
        }
      },
      async onCreateUltraRfp() {

        const crfqPartIds = this.requirementLines.map(part => part.id);
        //alert(crfqPartIds);
        const result = await this.createUltraRfp(crfqPartIds);
        this.hasRfp = await this.checkIfCrfqHasRfp(this.crfqId);

        this.$router.push({
          name: 'rfp.details',
          params: { id: result.key },
        });
      },
    },
    async mounted() {
      this.hasRfp = await this.checkIfCrfqHasRfp(this.crfqId);
    },
  };
</script>

<style lang="scss">
  .crfq-parts {
    .tools {
      margin-bottom: 10px;
    }
  }
</style>
